import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { loadAttaches } from '../thunks/attaches.thunk';
import { loadChatbotStartChat } from '../thunks/chatbotStartChat.thunk';
import { fieldActions } from './field';
import { IAttachesState, IAttachment, IAttachmentError } from './types';

const initialState: IAttachesState = {
  attachments: [],
  error: null,
  isLoading: false,
};

export const attachesSlice = createSlice({
  name: 'attaches',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<IAttachmentError>) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    attachesCloseError: (state) => {
      return {
        ...state,
        error: null,
      };
    },
    removeAttachment: (state, action) => {
      return {
        ...state,
        attachments: state.attachments.filter((i) => i.url !== action.payload),
        error: null,
      };
    },
    updateAttachment: (state, action: PayloadAction<IAttachment>) => {
      return {
        ...state,
        attachments: state.attachments.map((attachment) =>
          attachment.url !== action.payload.url ? attachment : action.payload,
        ),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAttaches.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });

    builder.addCase(loadAttaches.fulfilled, (state, action) => {
      return {
        ...state,
        attachments: [...state.attachments, ...action.payload],
        isLoading: false,
      };
    });

    builder.addCase(loadAttaches.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload ? action.payload : null,
        isLoading: false,
      };
    });

    builder.addCase(fieldActions.sendMessage, (state) => {
      return {
        ...state,
        attachments: [],
        error: null,
      };
    });

    builder.addCase(loadChatbotStartChat.fulfilled, (state, action) => {
      const { ui } = action.payload;

      return {
        isLoading: false,
        error: null,
        attachments: ui && Array.isArray(ui.attachments) ? ui.attachments : [],
      };
    });
  },
});
